import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-modal-layout',
  imports: [],
  templateUrl: './auth-modal-layout.component.html',
})
export class AuthModalLayoutComponent {}
